import DataTile from "./DataTile";
import {fetchRiskPortfolio} from "../../../actions";
import React from "react";
import {useSelector} from "react-redux";
import BreachRiskMeter from "../BreachRiskMeter/BreachRiskMeter";
import {
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbGetColorFromAPIFidelity,
    bbGetDisplayNameFromAPIFidelity,
    bbIsEntityAwaitingFirstScoreCycle,
    bbTranslateBreachRiskScoreToCategory
} from "../../../util/bbHelpers";
import RiskRibbon from "../../risk/RiskRibbon";
import {BRCustomizedTooltip, BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Skeleton from "react-loading-skeleton";
import BRFidelityBadge from "../BRPortfolio/BRFidelityBadge";
import BRCompanyScoreVerifiedBadge from "../BBRiskMeter/BRCompanyScoreVerifiedBadge";
import {Col, Row} from "reactstrap";
import BRCompanyScopeProgressBadge from "../BBRiskMeter/BRCompanyScopeProgressBadge";

const Tile = (props) => {

    const {customerId, entityId, displaySmall = false, overrideRibbonText = null, tipTextOverride=null} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);
    const {selfEntityId, entityInView} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customerId ? customerId : customerInView;
    const entityIdToUse = entityId ? entityId : entityInView ? entityInView : selfEntityId;


    const showBreachRiskMeterWith = (stateData) => {

        if (stateData && stateData[customerIdToUse]) {

            try {

                const {
                    [customerIdToUse] : {
                        entities
                    }
                } = stateData

                // const selfEntity = entities[entityIdToUse];
                const selfEntity = bbFindEntityWithinPortfolioOrSelf(entityIdToUse, stateData, customerIdToUse);
                const lastCycle = selfEntity && selfEntity.last_cycle ? selfEntity.last_cycle : null

                // console.log("TileBreachRiskScoreWithBasicDial here is selfEntity", selfEntity);

                const breachRiskScore = selfEntity.last_cycle ? Number(parseFloat(selfEntity.last_cycle.score).toFixed(1)) : null;
                //check to see if maybe the cycle is ongoing and that's why there is no score
                const breachRiskCategory = bbTranslateBreachRiskScoreToCategory(breachRiskScore);

                const lastCycleDatetime = selfEntity.last_cycle ? selfEntity.last_cycle.cycle_datetime : null;

                const entityName = selfEntity.name;
                //if there is a score, then show it. But if there is no score but there is a cycle ongoing, then show that too
                if(breachRiskScore){
                    return <div
                        className={"text-center"}
                    >
                        <Row>
                            <Col id={"tourBRScoreDial"}>
                                <h1>{entityName}</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <BreachRiskMeter
                                    currentValueText={`${breachRiskCategory} Risk`}
                                    width = {displaySmall ? 225 : 300}
                                    height = {displaySmall ? 150 : 200}
                                    value={breachRiskScore}
                                    valueTextFontSize={displaySmall ? '16px' : "26px"}
                                    hideNeedle={false}
                                />

                            </Col>
                        </Row>
                        <Row className={"flex-nowrap"}>
                            <Col sm = {3} >
                                {entityIdToUse &&
                                    <>
                                        <BRCompanyScopeProgressBadge entityId={entityIdToUse}/>
                                    </>
                                }
                            </Col>
                            <Col sm = {6} className={"m-1"}>
                                {lastCycle &&
                                    <>
                                        <Row>
                                            <Col>
                                                <BRFidelityBadge cycleObject={lastCycle}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <h4 ><Tooltip title={`This BreachRisk™ Score was assigned to ${entityName} on ${bbFormattedDateString(lastCycleDatetime,"medium")}.`}><em>{bbFormattedDateString(lastCycleDatetime, "short")}</em></Tooltip></h4>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </Col>
                            <Col sm = {3} >
                                {entityIdToUse &&
                                    <>
                                        <BRCompanyScoreVerifiedBadge entityId={entityIdToUse}/>
                                    </>
                                }
                            </Col>
                        </Row>

                    </div>
                } else if (bbIsEntityAwaitingFirstScoreCycle(selfEntity)) {
                    return <div
                        className={"text-center"}
                    >
                        <h3 id={"tourBRScoreDial"}>{entityName}</h3>
                        <BreachRiskMeter
                            currentValueText={`Pending`}
                            width = {displaySmall ? 225 : 300}
                            height = {displaySmall ? 150 : 200}
                            value={5}
                            valueTextFontSize={displaySmall ? '16px' : "26px"}
                            hideNeedle={true}

                        />
                        <h4><Tooltip title={`This BreachRisk™ scoring is in progress. Please check back later for results.`}><em>Scoring in progress... please check back soon.</em></Tooltip></h4>
                    </div>
                } else {
                    return <div
                        className={"text-center"}
                    >
                        <h3 id={"tourBRScoreDial"}>{entityName}</h3>
                        <BreachRiskMeter
                            currentValueText={`Information forthcoming`}
                            width = {displaySmall ? 225 : 300}
                            height = {displaySmall ? 150 : 200}
                            value={5}
                            valueTextFontSize={displaySmall ? '16px' : "26px"}
                            hideNeedle={true}

                        />
                        <h4><Tooltip title={`This BreachRisk™ scoring is in progress. Please check back later for results.`}><em>Scoring in progress...</em></Tooltip></h4>
                    </div>
                }


            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }


    const valueFunction = (stateData) => {

        try {
            const myEntity = bbFindEntityWithinPortfolioOrSelf(entityIdToUse, stateData, customerIdToUse);

            if(myEntity.last_cycle) {
                const riskScore = myEntity.last_cycle && myEntity.last_cycle.score ? parseFloat(myEntity.last_cycle.score).toFixed(1) : null;
                // const confidenceLow = myEntity.last_cycle ? parseFloat(myEntity.last_cycle.confidence_low).toFixed(1) : null;
                // const confidenceHigh = myEntity.last_cycle ? parseFloat(myEntity.last_cycle.confidence_high).toFixed(1) : null;
                //
                // const fidelityCategory = bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory(confidenceLow, confidenceHigh);

                return (
                // <Tooltip title={`${fidelityCategory} score. Risk could be between ${confidenceLow} and ${confidenceHigh}. Fidelity can be improved by providing attestations and increasing the rigor of your BreachRisk™ plan.`}>
            <span className={"tourBRScore"}>
                {`${riskScore}`}<small className={'text-muted'}> /10</small>
            </span>)
                // </Tooltip>;
            } else {
                return <>... <small className={'text-muted'}> /10</small></>
            }

        } catch (e) {
            return null;
        }

    }


    const riskRibbon = (stateData) => {
        // const confidenceLow = stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].entities ? stateData[customerIdToUse].entities[entityIdToUse] ? stateData[customerIdToUse].entities[entityIdToUse].last_cycle ? parseFloat(stateData[customerIdToUse].entities[entityIdToUse].last_cycle.confidence_low).toFixed(1) : null : null : null : null : null;
        // const confidenceHigh = stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].entities ? stateData[customerIdToUse].entities[entityIdToUse] ? stateData[customerIdToUse].entities[entityIdToUse].last_cycle ? parseFloat(stateData[customerIdToUse].entities[entityIdToUse].last_cycle.confidence_high).toFixed(1) : null : null : null : null : null;
        const lastCycle = stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].entities ? stateData[customerIdToUse].entities[entityIdToUse] ? stateData[customerIdToUse].entities[entityIdToUse].last_cycle ? stateData[customerIdToUse].entities[entityIdToUse].last_cycle : null : null : null : null : null;

        const fidelityCategory = lastCycle && lastCycle.fidelity ? bbGetDisplayNameFromAPIFidelity(lastCycle.fidelity, true) : null; //bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory(confidenceLow, confidenceHigh);
        return <RiskRibbon
            titleOverride={overrideRibbonText ? overrideRibbonText : fidelityCategory}
            tipTextOverride={ tipTextOverride ? tipTextOverride : `This BreachRisk™ Score was determined using methods with ${fidelityCategory}. Fidelity can be improved by providing attestations and increasing the rigor of your BreachRisk™ plan.`}
            styleName = {overrideRibbonText ? "" : `bg-${lastCycle && lastCycle.fidelity ? bbGetColorFromAPIFidelity(lastCycle.fidelity, true) : null}`}
            />
    }


    return (
        <DataTile
            // colorBgFunction={colorFunction}
            className={"tourBRScore"}
            subTitle="BreachRisk™ Score"
            tipText={`The BreachRisk™ Score describes the risk of a cyber breach to this company. It considers hundreds to thousands of direct and indirect observations using cyber attack tradecraft. Lower scores are better.`}
            icon={<div
                className={""}
                style={{ marginTop: 15 }}
            >
                <h3><Skeleton /></h3>
                <BreachRiskMeter
                    currentValueText={'Loading...'}
                    width = {displaySmall ? 225 : 300}
                    height = {displaySmall ? 150 : 200}
                    value={0}
                    valueTextFontSize={displaySmall ? '16px' : '26px'}
                    // hideNeedle

                />
                <h4><em><Skeleton /></em></h4>
            </div>}
            // icon={<BBIconBombs style={{fontSize: "70px"}}/>}
            iconFunction={showBreachRiskMeterWith}
            iconClasses = "size-400"
            stateName="breachrisk"
            stateElement="portfolios"
            //useDeepDataStore
            dontFetch
            //deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].vectors : null : null}
            stateLoaderName = {`loadingPortfolios`}
            stateLoaderError= {`loadingPortfoliosError`}
            deepLoaderIndex = {customerIdToUse}
            deepLoaderErrorIndex = {customerIdToUse}
            stateFetchAction={fetchRiskPortfolio(
                {
                    customerId: customerIdToUse
                }
            )}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            // showKRIRibbon
            //requiresModule={"perimeter"}
        />
    )

}

export default Tile;